export default __webpack_public_path__ + "static/media/DRUGSTICKER.fdb01a5d.png";